import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { getToken } from '../../../Session/SessionRedux';
import { getUserInfoData } from 'pgdb-data-layer/lib/Redux/UserInfoRedux';
import DashboardActions from 'pgdb-data-layer/lib/Redux/DashboardRedux';
import Navigator from '../../../Navigation/Navigator';
import './EndorsementPaymentSuccess.scss';
//This component is used when you submit an endorsement application or renewal without payment, so the message is slightly different to the EndorsementPaymentSuccess component. If there is a need in the future to have a separate page for endorsement submission success and payment success, we can create a new component for endorsement submission success and move this file to a more generic EndorsementSubmitSuccess.js file. For now, we can just use this component for both scenarios and pass in a prop to determine the message to display.
const EndorsementSubmitSuccess = ({ token, userContactData, getNotificationsRequest, isRenewal }) => {
   useEffect(() => {
      if (token && userContactData.contactId) {
         getNotificationsRequest(token);
      }
   }, [token, userContactData.contactId, getNotificationsRequest]);

   const handleContinue = () => {
      Navigator.toEndorsements();
   };

   return (
      <div className="section no-pad-bot endorsement-payment-success-container">
         <div className="container">
            <div className="row">
               <div className="col s12 m8 l6 offset-m2 offset-l3">
                  <div className="success-card">
                     <div className="success-icon">
                        <i className="material-icons">check_circle</i>
                     </div>
                     <h4 className="success-title">Congratulations!</h4>
                     <p className="success-message">
                        {isRenewal
                           ? 'Your endorsement renewal has been submitted successfully.'
                           : 'Your endorsement application has been submitted successfully.'}
                     </p>
                     <p className="success-message">
                        {isRenewal
                           ? 'You will receive a confirmation email shortly.'
                           : 'You will receive a confirmation email shortly.'}
                     </p>
                     <div className="button-container">
                        <button
                           type="button"
                           className="waves-effect waves-light btn"
                           onClick={handleContinue}
                        >
                           View Endorsement
                        </button>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};

const mapStateToProps = state => {
   return {
      token: getToken(state),
      userContactData: getUserInfoData(state.user),
   };
};

const mapDispatchToProps = {
   getNotificationsRequest: DashboardActions.getNotificationsRequest,
};

export default connect(
   mapStateToProps,
   mapDispatchToProps
)(EndorsementSubmitSuccess);
